import styled from 'styled-components/macro';

// utils
import mq from '../../../../utils/mediaQueriesBp';

// components
import { NavLink } from 'react-router-dom';

import ATCButton from '../../../../components/features/ATCButton';
import ATCDropdown from '../../../../components/features/ATCDropdown';
import AddToCalendarHOC from 'react-add-to-calendar-hoc';

const AddToCalendarDropdown = AddToCalendarHOC(ATCButton, ATCDropdown);

interface IProps {
  teaser_bg_color: string;
}

interface IDoctor {
  isDoctor: boolean;
}

const Wrapper = styled.div`
  display: flex;
  flex: 0 1 100%;
  flex-direction: column;
  cursor: pointer;
  margin-bottom: 20px;
  transition: all 0.5s ease-in-out;

  ${mq('laptop')} {
    flex: 0 1 45%;
    margin-bottom: 40px;
    margin-right: 30px;
  }

  ${mq('desktop')} {
    flex: 0 1 31%;
    margin-bottom: 60px;
    margin-right: 26px;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  ${mq('large')} {
    margin-right: 45px;
  }

  &:hover {
    box-shadow: 0px 4px 10px 2px rgba(0, 0, 0, 0.13);
  }
`;

const WebinarWrapper = styled.div`
  display: flex;
  flex: 0 1 100%;
  flex-direction: column;
  cursor: pointer;
  margin-bottom: 20px;
  transition: all 0.5s ease-in-out;
  transform: translateY(0);
  padding-top: 10px;

  ${mq('laptop')} {
    flex: 0 1 calc(50% - 15px);
    margin-bottom: 40px;
    margin-right: 30px;

    @media (max-width: 820px) {
      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }

  ${mq('desktop')} {
    flex: 0 1 23.29%;
    margin-bottom: 60px;
    margin-right: 26px;

    &:nth-child(4n) {
      margin-right: 0;
    }
  }

  ${mq('large')} {
    flex: 0 1 calc(25% - 34px);
    margin-right: 45px;
  }

  &:hover {
    box-shadow: 0px 10px 20px -5px #29293a1a;
    transform: translateY(-10px);
  }
`;

const WebinarImageWrapper = styled.div`
  position: relative;
`;

const WebinarImage = styled(NavLink)`
  display: flex;
  height: 172px;

  ${mq('laptop')} {
    height: 184px;
  }

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;

const WebinarHover = styled.div<IProps>`
  position: absolute;
  height: 50%;
  width: 100%;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    ${props =>
        props.teaser_bg_color !== '' ? props.teaser_bg_color : '#6DC7DD'}
      0%,
    rgba(3, 123, 193, 0) 100%
  );
  transform: rotate(-180deg);
  transition: all 0.5s ease;
`;

const WebinarDuration = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 23px;
  left: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${props => props.theme.colors.white};
  z-index: 1;

  ${mq('laptop')} {
    left: 30px;
  }

  svg {
    margin-right: 5px;
  }
`;

const WebinarAddToCalendarButton = styled(AddToCalendarDropdown)<IProps>`
  position: absolute;
  bottom: 15px;
  right: 15px;
  max-width: 170px;
  width: 100%;

  a.active {
    // &:before {
    //   background: ${props => props.theme.colors.white}
    // }

    // span {
    //   color: ${props =>
      props.teaser_bg_color !== '' ? props.teaser_bg_color : '#DBEBF2'};
    // }
  }

  a {
    &:hover {
      &:before {
        background: ${props => props.theme.colors.white};
      }

      span {
        color: ${props =>
          props.teaser_bg_color !== '' ? props.teaser_bg_color : '#DBEBF2'};
      }

      svg {
        fill: ${props =>
          props.teaser_bg_color !== '' ? props.teaser_bg_color : '#DBEBF2'};
      }
    }

    &.activeBtn {
      &:before {
        background: ${props => props.theme.colors.white};
      }

      span {
        color: ${props =>
          props.teaser_bg_color !== '' ? props.teaser_bg_color : '#DBEBF2'};
      }

      svg {
        fill: ${props =>
          props.teaser_bg_color !== '' ? props.teaser_bg_color : '#DBEBF2'};
      }
    }
  }
`;

const WebinarInner = styled.div`
  padding: 25px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;

  ${mq('laptop')} {
    padding: 25px;
  }
`;

const WebinarTitle = styled(NavLink)`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: ${props => props.theme.colors.black};
  text-decoration: none;
  width: 100%;
  margin-bottom: 10px;
`;

const WebinarSeoWrapper = styled.h2`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: ${props => props.theme.colors.black};
  text-decoration: none;
  width: 100%;
  margin-bottom: 10px;
`;

const WebinarTags = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const WebinarTag = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 5px;
  margin-bottom: 5px;
  cursor: pointer;

  &:before {
    content: '';
    display: inline-flex;
    position: absolute;
    left: -10px;
    width: 100%;
    height: 100%;
    transform: skewX(20deg);
    background: #ebebeb;
    border-radius: 5px;
    transition: 0.3s;
  }

  &:hover {
    &::before {
      background: #a4a4a4;
    }
  }
`;
const WebinarTagItem = styled.div`
  position: relative;
  padding: 4px 20px 4px 10px;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #696969;
`;

const WebinarLiveLabel = styled.div`
  display: inline-flex;
  position: relative;
  overflow: hidden;
  border-radius: 5px;

  &:before {
    content: '';
    display: inline-flex;
    position: absolute;
    left: -10px;
    width: 100%;
    height: 100%;
    transform: skewX(20deg);
    background: #e73458;
    border-radius: 5px;
    // z-index: -1;
  }

  .in-live {
    position: relative;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    padding: 7px 20px 7px 10px;
    color: ${props => props.theme.colors.white};
  }
`;
const WebinarInfo = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

const WebinarMeta = styled.div`
  position: relative;
  padding-right: 25px;

  button {
    position: absolute;
    right: 0;
    bottom: 5px;
    padding: 0;
  }
`;

const WebinarLiveAnimation = styled.div`
  position: absolute;
  right: 17px;
  top: 15px;
  z-index: 1;
`;

const WebinarListItem = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 5px;
  min-height: 369px;
  background: ${props => props.theme.colors.white};
  transition: all 0.3s;
  box-shadow: 0 0 0 1px #dbebf2;
  overflow: hidden;

  &:hover {
    box-shadow: 0 0 0 3px
      ${props =>
        props.teaser_bg_color !== '' ? props.teaser_bg_color : '#DBEBF2'};

    ${mq('desktop')} {
      transform: translateY(-10px);
    }

    &:before {
      box-shadow: 0px 4px 54px rgba(54, 86, 105, 0.3);
    }

    ${WebinarHover} {
      height: 100%;
    }

    ${WebinarAddToCalendarButton} {
      a {
        &:before {
          background: ${props => props.theme.colors.white};
        }

        span {
          color: ${props =>
            props.teaser_bg_color !== '' ? props.teaser_bg_color : '#6DC7DD'};
        }

        svg {
          fill: ${props =>
            props.teaser_bg_color !== '' ? props.teaser_bg_color : '#6DC7DD'};
        }
      }
    }
  }
`;

export {
  Wrapper,
  WebinarWrapper,
  WebinarListItem,
  WebinarImageWrapper,
  WebinarHover,
  WebinarImage,
  WebinarDuration,
  WebinarAddToCalendarButton,
  WebinarInner,
  WebinarInfo,
  WebinarTitle,
  WebinarLiveLabel,
  WebinarMeta,
  WebinarTags,
  WebinarTag,
  WebinarTagItem,
  WebinarLiveAnimation,
  WebinarSeoWrapper,
};
